import { TableBody, TableCell, TableRow, Typography, Button, Dialog, Box } from "@mui/material";
import { format } from "date-fns";
import { get } from "lodash";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import T from "utils/constants/T";

const AuditLogsTableBody = ({
    allTableRows,
}: {
    allTableRows: any[];
}) => {
    const { loader } = useSelector((state: any) => state.auditLogsData);
    const [openDialog, setOpenDialog] = useState(false);
    const [selectedDetails, setSelectedDetails] = useState<any>(null);

    const handleOpenDetails = (details: any) => {
        setSelectedDetails(details);
        setOpenDialog(true);
    };

    const handleCloseDetails = () => {
        setOpenDialog(false);
        setSelectedDetails(null);
    };

    if (loader) {
        return (
            <TableBody>
                <TableRow>
                    <TableCell colSpan={10} align="center" sx={{ borderBottom: "none" }}>
                    <Typography variant="body1">{T.LOADING}</Typography>
                    </TableCell>
                </TableRow>
            </TableBody>
        );
    }

    if (allTableRows?.length === 0) {
        return (
            <TableBody>
                <TableRow>
                    <TableCell colSpan={10} align="center" sx={{ borderBottom: "none" }}>
                        <Typography variant="body1">No Audit Logs found.</Typography>
                    </TableCell>
                </TableRow>
            </TableBody>
        );
    }

    return (
        <TableBody>
            {allTableRows?.map((row: any, index: number) => {
                const createdAt = get(row, "createdAt");
                const formattedDate = createdAt
                    ? format(new Date(createdAt), "dd MMM yyyy, hh:mm a")
                    : "-";

                const userFullName =
                    get(row, "user.full_name") ||
                    (row.user ? `${get(row.user, "first_name", "")} ${get(row.user, "last_name", "")}`.trim() : "-");
                // const userEmail = get(row, "user.email") || "-";
                const userRole = get(row, "role") || "-";
                const companyName = get(row, "company.name") || "-";
                const moduleName = get(row, "module") || "-";
                const actionName = get(row, "action") || "-";
                const status = get(row, "status") || "-";
                const description = get(row, "description") || "-";
                const ipAddress = get(row, "ip_address") || "-";

                let statusColor = "text.primary";
                if (status === "SUCCESS") statusColor = "success.main";
                if (status === "FAILED") statusColor = "error.main";

                return (
                    <TableRow hover key={row._id || index}>
                        <TableCell sx={{ padding: 1.5, borderBottom: "1px solid #f0f0f0" }}>
                            <Typography variant="body2">{formattedDate}</Typography>
                        </TableCell>
                        <TableCell sx={{ padding: 1.5, borderBottom: "1px solid #f0f0f0" }}>
                            <Typography variant="body2">{userFullName}</Typography>
                        </TableCell>
                        <TableCell sx={{ padding: 1.5, borderBottom: "1px solid #f0f0f0" }}>
                            <Typography variant="body2">{userRole}</Typography>
                        </TableCell>
                        <TableCell sx={{ padding: 1.5, borderBottom: "1px solid #f0f0f0" }}>
                            <Typography variant="body2">{companyName}</Typography>
                        </TableCell>
                        <TableCell sx={{ padding: 1.5, borderBottom: "1px solid #f0f0f0" }}>
                            <Typography variant="body2">{moduleName}</Typography>
                        </TableCell>
                        <TableCell sx={{ padding: 1.5, borderBottom: "1px solid #f0f0f0" }}>
                            <Typography variant="body2">{actionName}</Typography>
                        </TableCell>
                        <TableCell sx={{ padding: 1.5, borderBottom: "1px solid #f0f0f0" }}>
                            <Typography variant="body2">{ipAddress}</Typography>
                        </TableCell>
                        <TableCell sx={{ padding: 1.5, borderBottom: "1px solid #f0f0f0" }}>
                            <Typography variant="body2" sx={{ color: statusColor, fontWeight: 600 }}>{status}</Typography>
                        </TableCell>
                        <TableCell sx={{ padding: 1.5, borderBottom: "1px solid #f0f0f0" }}>
                            <Typography variant="body2" sx={{ maxWidth: 300, whiteSpace: "normal", wordWrap: "break-word" }}>{description}</Typography>
                        </TableCell>
                        <TableCell align="center" sx={{ padding: 1.5, borderBottom: "1px solid #f0f0f0" }}>
                            {row.details && Object.keys(row.details).length > 0 ? (
                                <Button variant="outlined" size="small" onClick={() => handleOpenDetails(row.details)}>
                                    View
                                </Button>
                            ) : (
                                "-"
                            )}
                        </TableCell>
                    </TableRow>
                );
            })}

            <Dialog open={openDialog} onClose={handleCloseDetails} maxWidth="md" fullWidth>
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        px: 3,
                        py: 2.5,
                        borderBottom: "1px solid #f0f0f0"
                    }}
                >
                    <Typography variant="h5" sx={{ fontWeight: 600, m: 0 }}>
                        Audit Log Details
                    </Typography>
                    <Button onClick={handleCloseDetails} color="primary" variant="contained">
                        Close
                    </Button>
                </Box>

                <Box sx={{ p: 3 }}>
                    <Box
                        sx={{
                            p: 2.5,
                            backgroundColor: "#f8f9fa",
                            borderRadius: 1.5,
                            border: "1px solid #e9ecef",
                            maxHeight: "65vh",
                            overflow: "auto"
                        }}
                    >
                        <pre
                            style={{
                                whiteSpace: "pre-wrap",
                                wordWrap: "break-word",
                                margin: 0,
                                fontSize: "14px",
                                color: "#333",
                                fontFamily: "'Roboto Mono', monospace"
                            }}
                        >
                            {JSON.stringify(selectedDetails, null, 2)}
                        </pre>
                    </Box>
                </Box>
            </Dialog>

        </TableBody>
    );
};

export default React.memo(AuditLogsTableBody);
